<template>
  <el-footer v-if="total > 25" class="pagination">
    <el-row>
      <el-col :span="12">
        <el-radio-group v-model="localPerPage" size="small">
          <el-radio-button :label="25"></el-radio-button>
          <el-radio-button :label="50"></el-radio-button>
          <el-radio-button :label="100"></el-radio-button>
        </el-radio-group>

        Items per page
      </el-col>

      <el-col :span="12">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="localPage"
          :page-size="localPerPage"
          :total="total"
          hide-on-single-page
        />
      </el-col>
    </el-row>
  </el-footer>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      localPerPage: this.perPage,
      localPage: this.page
    }
  },
  watch: {
    localPage (value) {
      this.$emit('update:page', value)
    },
    localPerPage (value) {
      this.$emit('update:perPage', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-footer {
    width: calc(100% - 230px);
    padding: 12px 48px;
    position: absolute;
    bottom: 0;
    border-top: 1px solid #e9eaf0;
    overflow: hidden;
  }
  .el-col + .el-col {
    text-align: right;
  }
  .el-radio-group {
    margin-right: 15px;
  }
</style>
